import type { ModelVersionInfo } from "../api/ml";
import { versionLabel } from "../lib/training";

/**
 * Which model version Save best.pt and Export ONNX act on (and, on the Auto-Annotate page, auto-annotation). Shown only
 * once there is a choice to make; with a single version the buttons keep doing what they always did.
 */
export function ModelVersionPicker({ versions, picked, onPick, testId, title = "Which version Save best.pt and Export ONNX use." }: {
  versions: ModelVersionInfo[]; picked: number | null; onPick: (v: number | null) => void; testId: string; title?: string;
}) {
  if (versions.length < 2) return null;
  const latest = versions.find((v) => v.is_latest) ?? versions[0];
  return (
    <div className="row" style={{ flexWrap: "nowrap", marginBottom: 6 }}>
      <span style={{ flex: "none" }}>Model version:</span>
      <select className="select" style={{ flex: 1, minWidth: 0 }} value={picked ?? latest.version_number} data-testid={testId}
        title={title}
        onChange={(e) => { const n = Number(e.target.value); onPick(n === latest.version_number ? null : n); }}>
        {versions.map((v) => <option key={v.version_number} value={v.version_number} disabled={!v.available}>{versionLabel(v)}</option>)}
      </select>
    </div>
  );
}
